var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_7_",
    "data-name": "map (7)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.521,
    height: 20.267,
    viewBox: "0 0 22.521 20.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#000000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    id: "Path_13",
    "data-name": "Path 13",
    d: "M22.52,159.7l-1.126-12.007a.375.375,0,0,0-.2-.3l-4.316-2.256c-.008,0-.017,0-.026-.007a.372.372,0,0,0-.078-.021.365.365,0,0,0-.077-.011c-.006,0-.011,0-.017,0a.352.352,0,0,0-.059.016.363.363,0,0,0-.061.011l-1.336.555a.375.375,0,0,0,.288.693l.85-.353.7,11.2L11.637,159.2V151.4a.375.375,0,1,0-.751,0V159.2L5.46,157.222l.7-11.2.85.353a.375.375,0,0,0,.288-.693l-1.336-.555a.366.366,0,0,0-.061-.011.356.356,0,0,0-.06-.016c-.006,0-.011,0-.017,0a.362.362,0,0,0-.08.011.371.371,0,0,0-.073.019c-.009,0-.019,0-.028.008l-4.316,2.256a.375.375,0,0,0-.2.3L0,159.7a.375.375,0,0,0,.536.373l4.549-2.187,6.045,2.2a.373.373,0,0,0,.257,0l6.045-2.2,4.549,2.187a.375.375,0,0,0,.536-.373ZM4.707,157.236l-3.9,1.873,1.045-11.143L5.4,146.113Zm13.109,0-.7-11.123,3.546,1.853,1.045,11.143Z",
    transform: "translate(-0.001 -139.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M171.113,30.947l2.985,5a.375.375,0,0,0,.645,0l2.993-5.017a3.563,3.563,0,0,0,.3-.714,3.531,3.531,0,0,0-.162-2.385,3.613,3.613,0,0,0-.807-1.153,3.75,3.75,0,0,0-1.193-.774,3.9,3.9,0,0,0-2.913,0,3.748,3.748,0,0,0-1.192.774,3.608,3.608,0,0,0-.808,1.154,3.531,3.531,0,0,0-.162,2.385A3.6,3.6,0,0,0,171.113,30.947Zm.538-2.811a2.863,2.863,0,0,1,.641-.915,3,3,0,0,1,.955-.62,3.134,3.134,0,0,1,2.347,0,3,3,0,0,1,.955.62,2.866,2.866,0,0,1,.641.915,2.781,2.781,0,0,1,.128,1.877,2.808,2.808,0,0,1-.234.55l-2.662,4.462-2.654-4.448a2.853,2.853,0,0,1-.242-.564,2.782,2.782,0,0,1,.128-1.877Z",
    transform: "translate(-163.16 -25.624)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M215.21,72.039a1.877,1.877,0,1,0-1.877-1.877A1.879,1.879,0,0,0,215.21,72.039Zm0-3a1.126,1.126,0,1,1-1.126,1.126A1.127,1.127,0,0,1,215.21,69.037Z",
    transform: "translate(-203.949 -66.41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.410e22af7c04a538db3aee5ff4d08d75.svg";
export { ForwardRef as ReactComponent };